import { render } from "./guideButton.vue?vue&type=template&id=15554614&scoped=true"
import script from "./guideButton.vue?vue&type=script&lang=js"
export * from "./guideButton.vue?vue&type=script&lang=js"

import "./guideButton.vue?vue&type=style&index=0&id=15554614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15554614"]])

export default __exports__